<template>
  <v-form>
    <v-container fluid>
      <v-card elevation="12" class="pa-10">
        <v-row>
          <v-col>
            <h2>Mecanismo de Ação - HRAC</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Grupo HRAC</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="modo_acao.grupo_hrac"
              :rules="fieldRequired"
              label="Grupo HRAC"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Grupo WSSA</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="modo_acao.grupo_wssa"
              :rules="fieldRequired"
              label="Grupo WSSA"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Mecanismo de Ação</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="modo_acao.modo_acao"
              :rules="fieldRequired"
              label="Mecanismo de Ação"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn dark style="margin-left: 5px; margin-top: 2px" color="green" @click="salvar">
              Salvar
            </v-btn>
            <v-btn
              style="margin-left: 5px; margin-top: 2px"
              color="gray"
              to="/hrac/modo-acao"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
    >
      {{ aviso }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { BASE_URL } from '../../util/constants';
export default {
  data: () => ({
    url: "https://apiadmin.allgeconsultoria.com/index.php/hrac/",
    overlay: false,
    snackbar: false,
    aviso: '',
    modo_acao: {
      id: "",
      grupo_hrac: '',
      modo_acao: '',
      grupo_wssa: '',
    },
    fieldRequired: [(v) => !!v || "Campo Obrigatorio"],
  }),
  created() {
    this.url = `${BASE_URL}hrac/`;
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== "") {
        await this.fetchModoAcao(this.$route.params.id);
      }
    },
    async fetchModoAcao(id) {
      try {
        let response = await fetch(`${this.url}modo-acao/${id}`);
        response = await response.json();
        this.modo_acao = response;
      } catch (error) {
        this.modo_acao = {
          id: "",
          grupo_hrac: '',
          modo_acao: '',
          grupo_wssa: '',
        };
      }
    },
    async salvar() {
      this.overlay = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("grupo_hrac", this.modo_acao.grupo_hrac);
      urlencoded.append("modo_acao", this.modo_acao.modo_acao);
      urlencoded.append("grupo_wssa", this.modo_acao.grupo_wssa);
      let method = (this.modo_acao.id === '' ? 'POST' : 'PUT')
      
      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: urlencoded,
      };

      fetch(`${this.url}modo-acao/${this.modo_acao.id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          this.overlay = false;
          this.aviso = 'Salvo com Sucesso';
          this.snackbar = true;
          setTimeout(() => this.$router.push(`/hrac/modo-acao/`), 1000)
        })
        .catch(error => {
          console.log(error)
          this.overlay = false;
          this.aviso = 'Problema ao Salvar, entre em contato com o suporte';
          this.snackbar = true;
        });
    }
  },
};
</script>
